import { getDashboardMenu, CustomSideMenu1 } from './dashboard';
import qpDashboard from 'sidemenu/menu-items(qp-admin)/dashboard';
// ==============================|| MENU ITEMS ||============================== //
const isSdCustomAdmin = localStorage.getItem('isSdCustomAdmin') === 'true';
const isQpAdmin = window.location.pathname.startsWith('/qp-admin');

export const getSuperDistributorMenuItems = () => {
    let selectedMenu;

    if (isSdCustomAdmin) {
        selectedMenu = CustomSideMenu1;
    } else if (isQpAdmin) {
        selectedMenu = qpDashboard;
    } else {
        selectedMenu = getDashboardMenu();
    }

    return {
        items: [selectedMenu]
    };
};

const superDistributorMenuItems = getSuperDistributorMenuItems();

export default superDistributorMenuItems;
